/**
 * PATH: packages/job-hub/src/jobs/qa/qaInlineMenuButtons.tsx
 * FILE_ID: JOBHUB-QA-INLINE-MENU-001
 * PURPOSE: Phone press actions as buttons in the list, under the pressed row.
 */
import type { ContextMenuItem as QaMenuItem } from '@quotech/ui'

export function QaInlineMenuButtons({
  items,
  onDone,
  className = 'max-h-[45vh] overflow-auto',
  control,
}: {
  items: QaMenuItem[]
  onDone: () => void
  className?: string
  control?: string
}) {
  return (
    // Reused from: packages/job-hub/src/jobs/tabs/job-qa/phone/sheets/QaPhoneRowActionsSheet.tsx (menu item button markup)
    <div className={className} data-qa-phone-control={control}>
      {items.map((item) => {
        if (item.kind === 'separator') return <div key={item.id} className="my-1 h-px bg-border" />
        if (item.kind === 'header') {
          return <p key={item.id} className="px-4 py-3 text-sm text-muted-foreground">{item.label}</p>
        }
        return (
          <button
            key={item.id}
            type="button"
            disabled={item.disabled}
            onClick={(event) => {
              if (item.disabled) return
              item.onSelect?.(event)
              onDone()
            }}
            className="flex min-h-[44px] w-full px-4 text-left text-sm disabled:opacity-40"
          >
            {item.label}
          </button>
        )
      })}
    </div>
  )
}
